"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerLazyViewer = void 0;
var tslib_1 = require("tslib");
var react_module_container_1 = require("react-module-container");
var interfaces_1 = require("../interfaces");
var fileNames = function (debug) { return [
    "dealer-viewer-module.bundle" + (debug ? '' : '.min') + ".js",
    "dealer-viewer-module" + (debug ? '' : '.min') + ".css",
]; };
var DealerLazyViewer = /** @class */ (function (_super) {
    tslib_1.__extends(DealerLazyViewer, _super);
    function DealerLazyViewer(props) {
        var _this = this;
        if (props.viewerUrl) {
            _this = _super.call(this, props, {
                files: fileNames(props.debug).map(function (fileName) { return "" + props.viewerUrl + fileName; }),
                component: 'DealerReactViewer.main',
            }) || this;
        }
        else {
            throw new Error('No dealer-react-viewer url supplied');
        }
        return _this;
    }
    DealerLazyViewer.propTypes = interfaces_1.viewerPropTypes;
    DealerLazyViewer.defaultProps = interfaces_1.viewerDefaultProps;
    return DealerLazyViewer;
}(react_module_container_1.ReactLazyComponent));
exports.DealerLazyViewer = DealerLazyViewer;
//# sourceMappingURL=DealerLazyLoader.js.map